<div
    *ngIf="showDropdown"
    class="agpr-formField agpr-textField"
>
    <agpr-dropdown
        [id]="id + '.dropdown'"
        [options]="options"
        [placeholder]="field.placeholder"
        [inputTooltip]="inputTooltip"
        [label]="field.label"
        [labelClass]="labelClass"
        [ariaLabel]="ariaLabel"
        [panelStyleClass]="field.panelStyleClass"
        [labelStyleClass]="field.labelStyleClass"
        [(ngModel)]="selectedOption"
        (ngModelChange)="onDropdownChanged($event.value)"
    ></agpr-dropdown>
    <div
        *ngIf="field.description"
        class="agpr-formField-description"
    >
        {{ field.description | localize }}
    </div>
</div>
